<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="订单ID">
                  <el-input  v-model="queryForm.orderId"></el-input>
              </el-form-item>
              <el-form-item label="订单编码">
                  <el-input  v-model="queryForm.orderCode"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopOrderCodeList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addShopOrderCode"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editShopOrderCode(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopOrderCode(null)"
        >删除</el-button>
          <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              @click="openMoreDialog"
          >批量生成</el-button>
		  <el-button type="primary" size="small" icon="el-icon-plus" @click="download">下载</el-button>
          <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              @click="openPrintDialog"
          >批量打印</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportShopOrderCodeList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopOrderCodeList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopOrderCodeList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderId"
        label="订单ID"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderCode"
        label="订单编码"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
<!--            <div @click="checkShopOrderCode(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Eye24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">查看</span>-->
<!--            </div>-->
<!--            <div @click="editShopOrderCode(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteShopOrderCode(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopOrderCodeStates[shopOrderCodeState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopOrderCode"
          ref="shopOrderCodeForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="订单ID"
            prop="orderId"
          >
            <el-input
              size="small"
              v-model="shopOrderCode.orderId"
              :disabled="shopOrderCodeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单编码"
            prop="orderCode"
          >
            <el-input
              size="small"
              v-model="shopOrderCode.orderCode"
              :disabled="shopOrderCodeState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopOrderCodeState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>

      <el-dialog
          :title="'批量生成'"
          :visible.sync="moreDialog"
          width="400px"
          @close="closeMoreDialog"
      >
          <el-form
              ref="mores"
              :inline="true"
              :model="queryObj"
              :rules="countCodeRules"
              size="small"
              label-width="80px"
          >
              <el-form-item
                  label="生成数量"
                  prop="countCode"
              >
                  <el-input
                      size="small"
                      v-model="queryObj.countCode"
                  ></el-input>
              </el-form-item>
          </el-form>
          <div slot="footer" class="flex justify-end">
              <el-button @click="closeMoreDialog">关闭</el-button>
              <el-button
                  type="primary"
                  @click="submitQuery('more')"
              >确定</el-button>
          </div>
      </el-dialog>

      <el-dialog
          :title="'批量打印'"
          :visible.sync="printDialog"
          width="400px"
          @close="closePrintDialog"
      >
          <el-form
              ref="prints"
              :inline="true"
              :model="queryObj"
              :rules="countCodeRules"
              size="small"
              label-width="80px"
          >
              <el-form-item
                  label="打印区间"
                  prop="startCount"
              >
                  <el-input
                      size="small"
                      v-model="queryObj.startCount"
                      placeholder="请输入开始数字"
                  ></el-input>
                  <br>
                  <el-input
                      size="small"
                      v-model="queryObj.endCount"
                      placeholder="请输入结束数字"
                  ></el-input>
              </el-form-item>
          </el-form>
          <div slot="footer" class="flex justify-end">
              <el-button @click="closePrintDialog">关闭</el-button>
              <el-button
                  type="primary"
                  @click="submitQuery('print')"
              >确定</el-button>
          </div>
      </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopOrderCodeList();
                    this.getShopOrderCodeList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopOrderCodeList();
                    this.getShopOrderCodeList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     orderId: '', //订单ID
                     orderCode: '', //订单编码
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopOrderCodeState: 'add',
                shopOrderCodeStates: {
                    add: '新建shop_order_code',
                    check: '查看shop_order_code',
                    edit: '修改shop_order_code'
                },

                multipleSelection: [],
                shopOrderCodeList: [],
                shopOrderCode: {
                    id: '', //ID
                    orderId: '', //订单ID
                    orderCode: '', //订单编码
                },
                btnLoading: false,

                rules: {
                    orderId: [{ required: true, message: '订单ID不能为空', trigger: 'blur' }],
                    orderCode: [{ required: true, message: '订单编码不能为空', trigger: 'blur' }],
                },


                countCodeRules: {
                    countCode: [{ required: true, message: '生成数量不能为空', trigger: 'blur' }],
                    startCount: [{ required: true, message: '开始数字不能为空', trigger: 'blur' }],
                    endCount: [{ required: true, message: '结束数字不能为空', trigger: 'blur' }],
                },
                moreDialog: false,
                printDialog: false,
                queryObj:{
                    countCode: '',
                    startCount: '',
                    endCount: '',
                }
            };
        },
        created() {
            this.getShopOrderCodeList();
        },
        methods: {
            openMoreDialog(){
                this.moreDialog = true
            },
            closeMoreDialog(){
                this.moreDialog = false
            },

            openPrintDialog(){
                this.printDialog = true
            },
            closePrintDialog(){
                this.printDialog = false
            },
            resetQuery(){
                this.queryObj = {
                    countCode: '',
                    startCount: '',
                    endCount: '',
                }
            },
			download(){
			  post('/washcloud/ordercode/download',{}).then((res) => {
			    if (res.success) {
			      console.log(res)
			      window.open(res.url)
			    }else {
			      this.$message({
			        message: res.msg,
			        type: 'error',
			        duration: 2000
			      });
			    }
			  })
			},
            submitQuery(val){
                if(val == 'more'){
                    this.$refs.mores.validate((valid) => {
                        get('/washcloud/ordercode/addBatch',{number: this.queryObj.countCode}).then((res)=>{
                            if(res.success){
                                this.$message.success(res.msg)
                                this.closeMoreDialog()
                                this.resetQuery()
                                this.getShopOrderCodeList()
                            }else{
                                this.$message.error(res.msg)
                            }
                        })
                    })
                }else if(val == 'print'){
                    this.$refs.prints.validate((valid) => {
                        get('/washcloud/ordercode/printBatch',{startCode: this.queryObj.startCount,endCode: this.queryObj.endCount}).then((res)=>{
                            if(res.success){
                                this.$message.success(res.msg)
                                this.closePrintDialog()
                                this.resetQuery()
                                this.getShopOrderCodeList()
                            }else{
                                this.$message.error(res.msg)
                            }
                        })
                    })
                }
            },


            search(){
                this.isSearch = !this.isSearch;
            },
            resetShopOrderCodeList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopOrderCodeList = [];
            },
            resetDialog() {
                this.shopOrderCodeState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      orderId: '', //订单ID
                      orderCode: '', //订单编码
                };
                this.getShopOrderCodeList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopOrderCode = {
                      id: '', //ID
                      orderId: '', //订单ID
                      orderCode: '', //订单编码
                };
            },
            submitForm() {
                if (this.shopOrderCodeState == 'add') {
                    this.$refs.shopOrderCodeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/washcloud/ordercode/add`,{ ...this.shopOrderCode }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopOrderCodeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopOrderCodeState == 'edit') {
                    this.$refs.shopOrderCodeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/washcloud/ordercode/edit`,{ ...this.shopOrderCode }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopOrderCodeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopOrderCode() {
                this.showDialog = true;
                this.shopOrderCodeState = 'add';
            },
            checkShopOrderCode(shopOrderCodeId) {
                console.log(shopOrderCodeId);
                this.currentShopOrderCodeId = shopOrderCodeId;

                this.getShopOrderCodeById();
                this.showDialog = true;
                this.shopOrderCodeState = 'check';
            },
            editShopOrderCode(shopOrderCodeId) {
                console.log('shopOrderCode', shopOrderCodeId);
                if (shopOrderCodeId) {
                    this.currentShopOrderCodeId = shopOrderCodeId;
                    this.getShopOrderCodeById();
                } else {
                    this.shopOrderCode = { ...this.shopOrderCode, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopOrderCodeState = 'edit';
            },
            deleteShopOrderCode(shopOrderCodeId) {
                let ids = '';
                if (shopOrderCodeId) {
                    ids = shopOrderCodeId;
                } else {
                    ids = this.multipleSelection.map((shopOrderCode) => shopOrderCode.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/washcloud/ordercode/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopOrderCodeList();
                                this.getShopOrderCodeList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopOrderCodeList() {
                this.resetShopOrderCodeList();
                this.getShopOrderCodeList();
            },
            getShopOrderCodeList(query = {}) {
                this.loading = true;
                get(`/washcloud/ordercode/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopOrderCodeList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopOrderCodeById() {
                get(`/washcloud/ordercode/get`,{ id: this.currentShopOrderCodeId }).then((res) =>{
                    if(res.success){
                      this.shopOrderCode = { ...this.shopOrderCode, ...res.shopOrderCode };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopOrderCodeList() {
                //this.btnLoading = true;
                exprotExcel(`/washcloud/ordercode/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/washcloud/ordercode/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/washcloud/ordercode/importData`,formData);
              this.refreshShopOrderCodeList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopOrderCodeList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopOrderCodeList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>